const assignedProps = type => (payload = null, callback = null) =>
  (!callback) ? (payload) ? { type, payload } : { type } : { type, payload, callback }

export const actionCreator = (obj) => {
  return Object.keys(obj).reduce((acc, action) => ({
    ...acc,
    [action]: assignedProps(obj[action])
  })
  , {})
}
